import React, { useEffect, useState } from "react";
import {
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  TableContainer,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  Button,
  useDisclosure,
  Center,
  Textarea,
  HStack,
  Tooltip,
  IconButton,
} from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import {
  addTestimonialsAsync,
  deleteTestimonialsAsync,
  fetchTestimonialsAsync,
  selectTestimonials,
  updateTestimonialsAsync,
} from "./TestimonialsSlice";
import { useForm } from "react-hook-form";
import { DeleteIcon, EditIcon } from "@chakra-ui/icons";

function Testing() {
  const {
    isOpen: isOpen1,
    onOpen: onOpen1,
    onClose: onClose1,
  } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();

  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();
  const testimony = useSelector(selectTestimonials);

  useEffect(() => {
    dispatch(fetchTestimonialsAsync());
  }, []);

  const [newTestimonials, setnewTestimonials] = useState("");
  const [newStatus, setnewStatus] = useState(""); // Add status state
  const [error, setError] = useState(null);
  const [editTestimonials, seteditTestimonials] = useState("");
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editStatus, seteditStatus] = useState("");
  const [editableTestimonials, seteditableTestimonials] = useState(null);
  const [deletingTestimonials, setdeletingTestimonials] = useState(null);

  const handleDelete = async (uuid) => {
    await dispatch(deleteTestimonialsAsync({ uuid }));
    dispatch(fetchTestimonialsAsync());
    onClose2();
  };

  const openDeleteModal = (job) => {
    setdeletingTestimonials(job);
    dispatch(fetchTestimonialsAsync());

    onOpen2();
  };

  const handleSave = async (data) => {
    const newTestimonials = {
      name: data.name,
      designation: data.designation,
      company_name: data.company_name,
      review_description: data.review_description,
      review_rating: data.review_rating,
      status: data.status,
    };

    try {
      // console.log("New Testimonial:", newTestimonials);
      await dispatch(addTestimonialsAsync({ newTestimonials }));

      dispatch(fetchTestimonialsAsync());
      reset(); // Clear form fields
      onClose1();
    } catch (err) {
      setError(err.message);
    }
  };
  const handleEdit = (TestimonialsData) => {
    seteditableTestimonials(TestimonialsData); // Ensure this contains `uuid`
    setValue("name", TestimonialsData.name);
    setValue("designation", TestimonialsData.designation);
    setValue("company_name", TestimonialsData.company_name);
    setValue("review_description", TestimonialsData.review_description);
    setValue("review_rating", TestimonialsData.review_rating);
    setValue("status", TestimonialsData.status);
    setIsEditModalOpen(true);
  };

  // console.log("Editable Testimonial:", editableTestimonials);

  const handleUpdate = async (data) => {
    if (!editableTestimonials || !editableTestimonials.uuid) {
      setError("Unable to update: UUID is missing.");
      return;
    }

    const updatedTestimonials = {
      name: data.name,
      designation: data.designation,
      company_name: data.company_name,
      review_description: data.review_description,
      review_rating: data.review_rating,
      status: data.status,
    };

    try {
      console.log("Editable Testimonial inside update:", editableTestimonials);
      await dispatch(
        updateTestimonialsAsync({
          uuid: editableTestimonials.uuid, // Ensure this is not null
          testimonialsData: updatedTestimonials,
        })
      );

      dispatch(fetchTestimonialsAsync());
      seteditableTestimonials(null); // Clear editable testimonial
      reset(); // Reset form fields
      setIsEditModalOpen(false); // Close the modal
    } catch (err) {
      setError(err.message);
    }
  };

  const TruncatedText = ({ text, maxWords }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    // Split the text into words and check if it exceeds maxWords
    const words = text?.split(" ");
    const shouldTruncate = words?.length > maxWords;

    // Get the truncated text
    const truncatedText = shouldTruncate
      ? words?.slice(0, maxWords).join(" ") + "..."
      : text;

    return (
      <div>
        {isExpanded ? text : truncatedText}
        {shouldTruncate && (
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="text-blue-500 hover:text-blue-700 ml-2 text-sm font-medium"
          >
            {isExpanded ? "Show less" : "Show more"}
          </button>
        )}
      </div>
    );
  };

  return (
    <div
      className="h-screen bg-adminbg contentAdmin p-4"
      style={{ fontFamily: "Inter, sans-serif" }}
    >
      <div className=" ">
        <div className="w-full my-5 bg-white rounded-xl">
          <div className="flex justify-between">
            <p className="text-xl text-black font-semibold px-3 py-7">
              Testimonials List
            </p>
            <div className="py-4 px-3 flex gap-3">
              <Button
                colorScheme="blue"
                fontSize={"medium"}
                alignContent={"center"}
                onClick={onOpen1}
              >
                Add<i className="fa-solid fa-plus px-2"></i>
              </Button>

              <Modal isOpen={isOpen1} onClose={onClose1}>
                <ModalOverlay />
                <ModalContent maxW={"2xl"}>
                  <form onSubmit={handleSubmit(handleSave)} className="p-4">
                    <h4 className="py-2">Add Testimonial:</h4>
                    <Input
                      className="border-black"
                      color="black"
                      placeholder="Enter Name"
                      {...register("name", { required: true })}
                    />
                    <Input
                      className="border-black"
                      color="black"
                      placeholder="Enter Designation"
                      {...register("designation", { required: true })}
                    />
                    <Input
                      className="border-black"
                      color="black"
                      placeholder="Enter Company Name"
                      {...register("company_name", { required: true })}
                    />
                    <Textarea
                      className="border-black"
                      color="black"
                      placeholder="Enter Review Description"
                      {...register("review_description", { required: true })}
                    />
                    <Input
                      className="border-black"
                      color="black"
                      placeholder="Enter Review Rating"
                      type="number"
                      {...register("review_rating", {
                        required: true,
                        min: 1,
                        max: 5,
                      })}
                    />
                    <Input
                      className="border-black"
                      color="black"
                      placeholder="Enter Status"
                      {...register("status", { required: true })}
                    />
                    <div className="w-full flex justify-center gap-2 mt-5">
                      <Button colorScheme="blue" className="w-64" type="submit">
                        Save
                      </Button>
                      <Button
                        colorScheme="blue"
                        textColor={"blue"}
                        variant={"outline"}
                        className="w-64"
                        onClick={onClose1}
                      >
                        Cancel
                      </Button>
                    </div>
                    {error && <p className="text-red-500">{error}</p>}
                  </form>
                </ModalContent>
              </Modal>
              <Modal
                isOpen={isEditModalOpen}
                onClose={() => setIsEditModalOpen(false)}
              >
                <ModalOverlay />
                <ModalContent maxW={"2xl"}>
                  <form
                    onSubmit={handleSubmit(handleUpdate)}
                    className="p-4"
                  >
                    <h4 className="py-2">Edit Testimonials:</h4>

                    <Input
                      className="border-black"
                      color="black"
                      placeholder="Enter Name"
                      {...register("name", { required: true })}
                    // defaultValue="Abhishek Tiwari"
                    />

                    <Input
                      className="border-black"
                      color="black"
                      placeholder="Enter Designation"
                      {...register("designation", {
                        required: true,
                      })}
                    // defaultValue="System Analyst"
                    />

                    <Input
                      className="border-black"
                      color="black"
                      placeholder="Enter Company Name"
                      {...register("company_name", {
                        required: true,
                      })}
                    // defaultValue="Googlee"
                    />

                    <Textarea
                      className="border-black"
                      color="black"
                      placeholder="Enter Review Description"
                      {...register("review_description", {
                        required: true,
                      })}
                    // defaultValue="Very good products"
                    />

                    <Input
                      className="border-black"
                      color="black"
                      placeholder="Enter Review Rating"
                      type="number"
                      {...register("review_rating", {
                        required: true,
                        min: 1,
                        max: 5,
                      })}
                    // defaultValue="3"
                    />

                    <Input
                      className="border-black"
                      color="black"
                      placeholder="Enter Status"
                      {...register("status", {
                        required: true,
                      })}
                      defaultValue="active"
                    />

                    <div className="w-full flex justify-center gap-2 mt-5">
                      <Button
                        colorScheme="blue"
                        className="w-64"
                        type="submit"
                      >
                        Update
                      </Button>
                      <Button
                        colorScheme="blue"
                        textColor={"blue"}
                        variant={"outline"}
                        className="w-64"
                        onClick={() =>
                          setIsEditModalOpen(false)
                        }
                      >
                        Cancel
                      </Button>
                    </div>
                    {error && (
                      <p className="text-red-500">{error}</p>
                    )}
                  </form>
                </ModalContent>
              </Modal>
              <Modal
                isOpen={isOpen2}
                onClose={onClose2}
                alignContent={Center}
              >
                <ModalOverlay />
                <ModalContent maxW={"2xl"}>
                  <div className="p-4">
                    <h4 className="py-2">
                      Are you sure you want to delete "
                      {deletingTestimonials?.name}" ? :
                    </h4>
                    <div className="w-full flex justify-center gap-2 mt-4">
                      <Button
                        colorScheme="red"
                        className="w-48"
                        // variant={"outline"}
                        onClick={() =>
                          handleDelete(
                            deletingTestimonials.uuid
                          )
                        }
                      >
                        Delete
                      </Button>
                      <Button
                        colorScheme="red"
                        textColor={"red"}
                        variant={"outline"}
                        className="w-48"
                        onClick={onClose2}
                      >
                        Cancel
                      </Button>
                    </div>
                  </div>
                </ModalContent>
              </Modal>
            </div>
          </div>
          <TableContainer>
            <Table size="sm">
              <Thead className="bg-gray-200">
                <Tr>
                  <Th className="w-1/5">Name</Th>
                  <Th className="w-1/5">Designation</Th>
                  <Th className="w-1/5">Company Name</Th>
                  <Th className="w-1/5">review_description </Th>
                  <Th className="w-1/5">review_rating </Th>
                </Tr>
              </Thead>
              <Tbody>
                {testimony && testimony.length > 0 ? (
                  [...testimony]
                    .sort((a, b) => a.id - b.id)
                    .map((job) => (
                      <Tr key={job.id}>
                        <Td>{job.name}</Td>
                        <Td>{job.designation}</Td>
                        <Td>{job.company_name}</Td>
                        <Td textColor={"green"}>
                          <TruncatedText
                            text={job.review_description}
                            maxWords={5}
                          />
                        </Td>
                        <Td>
                          {/* <div className="text-sm opaTestimonials-90 text-blue-700 flex">
                            <div>
                              <i className="fa-solid fa-eye mr-3.5"></i>
                            </div>
                            <div>
                              <button onClick={() => handleEdit(job)}>
                                <i className="fa-solid fa-pencil mr-3.5"></i>
                              </button>
                            </div>
                            <div className="">
                              <button onClick={() => openDeleteModal(job)}>
                                {" "}
                                <i className="cursor-pointer fa-solid fa-trash-can-arrow-up mr-3.5"></i>
                              </button>
                            </div>
                          </div> */}

                          <HStack spacing={2}>
                            <Tooltip label="Edit " placement="top">
                              <IconButton
                                icon={<EditIcon />}
                                colorScheme="blue"
                                size="sm"
                                onClick={() => handleEdit(job)}
                                aria-label="Edit industry"
                              />
                            </Tooltip>
                            <Tooltip label="Delete " placement="top">
                              <IconButton
                                icon={<DeleteIcon />}
                                colorScheme="red"
                                size="sm"
                                onClick={() => openDeleteModal(job)}
                                aria-label="Delete industry"
                              />
                            </Tooltip>
                          </HStack>
                        </Td>
                      </Tr>
                    ))
                ) : (
                  <Tr>
                    <Td colSpan="5" className="text-center py-4 text-gray-500">
                      No data available
                    </Td>
                  </Tr>
                )}
              </Tbody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </div>
  );
}

export default Testing;
